import type { CollectionJob } from "@/services/api/collection-jobs";
import { CollectionJobsTableHeader } from "./CollectionJobsTableHeader";
import { CollectionJobsTableRow } from "./CollectionJobsTableRow";

interface CollectionJobsTableProps {
  jobs: CollectionJob[];
  onCancel: (job: CollectionJob) => void;
  isCancelling?: boolean;
  sortColumn?: string;
  sortDirection?: "asc" | "desc";
  onSort: (column: string) => void;
}

export function CollectionJobsTable({
  jobs,
  onCancel,
  isCancelling = false,
  sortColumn,
  sortDirection,
  onSort,
}: CollectionJobsTableProps) {
  if (jobs.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-ink-500">
        No collection jobs found.
      </div>
    );
  }

  return (
    <div 
      className="overflow-x-auto overflow-y-auto" 
      style={{ 
        maxHeight: 'calc(100vh - 24rem)',
        scrollbarGutter: 'stable'
      }}
    >
      <table className="w-full">
        <CollectionJobsTableHeader
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <tbody className="divide-y divide-grid-200">
          {jobs.map((job) => (
            <CollectionJobsTableRow
              key={job.id}
              job={job}
              onCancel={onCancel}
              isCancelling={isCancelling}
            />
          ))}
        </tbody>
      </table>
      <div className="h-4" aria-hidden="true" />
    </div>
  );
}
